
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 26,
  viewBox: "0 0 18 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 12.707c-2.207 0-3.996-1.762-3.996-3.936 0-2.173 1.79-3.935 3.996-3.935 2.207 0 3.996 1.762 3.996 3.935 0 2.174-1.79 3.936-3.996 3.936m8.998-3.936C17.946 3.927 13.93 0 9 0c-.065 0-.128.008-.192.01C3.967.11.053 3.99.002 8.77L0 8.865c0 2.756 2.34 7.538 3.734 10.143.914 1.705 1.883 3.339 2.73 4.602 1.232 1.84 1.777 2.302 2.345 2.377.063.008.127.013.192.013.642 0 1.187-.358 2.552-2.39.845-1.258 1.813-2.893 2.727-4.604 1.389-2.6 3.72-7.378 3.72-10.141l-.002-.094",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg width=\"18\" height=\"26\" viewBox=\"0 0 18 26\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M9 12.707c-2.207 0-3.996-1.762-3.996-3.936 0-2.173 1.79-3.935 3.996-3.935 2.207 0 3.996 1.762 3.996 3.935 0 2.174-1.79 3.936-3.996 3.936m8.998-3.936C17.946 3.927 13.93 0 9 0c-.065 0-.128.008-.192.01C3.967.11.053 3.99.002 8.77L0 8.865c0 2.756 2.34 7.538 3.734 10.143.914 1.705 1.883 3.339 2.73 4.602 1.232 1.84 1.777 2.302 2.345 2.377.063.008.127.013.192.013.642 0 1.187-.358 2.552-2.39.845-1.258 1.813-2.893 2.727-4.604 1.389-2.6 3.72-7.378 3.72-10.141l-.002-.094\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"evenodd\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/Fill.da98d5d15e18b8cfebdf3b08bb0d06d2.svg"),
        {
          React: SvgFill,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      